import React from 'react';

const Icon = ({ size = '16', fill = '#03060B', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...other}>
            <circle cx="8" cy="8" r="7.55" stroke="black" strokeWidth="0.9" />

            <path
                d="M7.627 10.909c.31 0 .577.067.788.202.197.135.31.309.31.52 0 .213-.113.396-.324.53-.21.136-.464.203-.774.203s-.563-.077-.774-.212c-.212-.135-.31-.308-.31-.52 0-.212.098-.386.31-.52.21-.136.464-.203.774-.203Zm.51-7.273c.826 0 1.5.211 2.008.658.508.434.762 1.029.762 1.785 0 .62-.165 1.128-.47 1.524-.114.124-.483.46-1.092.98a1.933 1.933 0 0 0-.51.62c-.126.248-.19.508-.19.806v.173h-1.46v-.174c0-.47.077-.88.254-1.214.166-.335.661-.856 1.487-1.575l.152-.173c.229-.273.343-.57.343-.88 0-.41-.127-.732-.356-.968-.24-.236-.584-.347-1.016-.347-.559 0-.953.161-1.195.508-.215.285-.317.695-.317 1.216H5.09c0-.917.267-1.637.826-2.157.546-.52 1.283-.782 2.223-.782Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
